var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "info-flag": _vm.infoFlag || _vm.streetFlag } },
    [
      _vm._t("advise"),
      _vm._v(" "),
      _c("div", {
        staticClass: "kernel-map",
        staticStyle: { position: "absolute", "z-index": "2" },
        attrs: { id: "map" }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Map.vue?vue&type=template&id=61d54e3e&
// module id = null
// module chunks = 